//Parroquias de Delta amacuro
const munAntonioDiaz = [
  'Curiapo',
  'Almirante Luis Brión',
  'Francisco Aniceto Lugo',
  'Manuel Renaud',
  'Padre Barral',
  'Santos De Abelgas',
];
const munCasacoima = [
  'Imataca',
  'Cinco De Julio',
  'Juan Bautista Arismendi',
  'Manuel Piar',
  'Romulo Gallegos',
];
const munPedernales = ['Pedernales', 'Luis Beltrán Prieto Figueroa'];
const munTucupita = [
  'San José',
  'José Vidal Marcano',
  'Juan Millán',
  'Leonardo Ruíz Pineda',
  'Mariscal Antonio José De Sucre',
  'Monseñor Argimiro García',
  'San Rafael',
  'Virgen Del Valle',
];

export const esDeltaAmacuro = [
  {
    municipio: 'Antonio Díaz',
    parroquias: munAntonioDiaz,
  },
  {
    municipio: 'Casacoima',
    parroquias: munCasacoima,
  },
  {
    municipio: 'Pedernales',
    parroquias: munPedernales,
  },
  {
    municipio: 'Tucupita',
    parroquias: munTucupita,
  },
];
